export default __webpack_public_path__ + "static/media/c10.904e8c8e.PNG";